<template>
  <el-container>
    <el-header :style="headerStyle">
      <span class="title-header">{{ title }}</span>
    </el-header>
    <el-main>
      <el-row :gutter="20">
        <el-col :span="12" v-for="item in menuWithChildren" :key="item.arme_id">
          <div class="grid-card-campaign">
            <div class="icon" :style="`background: linear-gradient(135deg, #006db3, #00c4ff); flex-direction: column;`"> 
              <el-row justify="center" align="middle">
                <el-col>
                </el-col>
              </el-row>
              <el-row justify="center" align="middle">
                <el-col :style="`color:${color_text}`" class="text-center-container" :span="12">
                  <small>
                    {{ item.arme_nombre }}
                  </small>
                </el-col>
              </el-row>
            </div>

            <div class="content" :style="`height:${height};`">
              <el-row v-for="child in item.children" :key="child.arme_id" justify="start" align="middle">
                <el-col>
                  <small class="text-center" @click="
                    redirectToPath(
                      child.arme_ruta,
                      child.arme_tipo,
                      child.arme_id
                    )
                    ">
                    {{ child.arme_nombre }}
                  </small>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>

        <el-col :span="12" v-if="menuWithoutChildren.length > 0">
          <div class="grid-card-campaign-without-children">
            <div class="icon" :style="`background: linear-gradient(135deg, #006db3, #00c4ff); 
           color: ${variant}; 
           box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1); 
           border-top-left-radius: 10px;
           border-bottom-left-radius: 10px; 
           flex-direction: column;`"> 
              <el-row justify="center" align="middle">
                <el-col>
                  <!-- <users style="color: #fff" /> -->
                </el-col>
              </el-row>
              <el-row justify="center" align="middle">
                <el-col :style="`color:${color_text}`" class="text-center-container" :span="12">
                  <small>
                    {{ title }}
                  </small>
                </el-col>
              </el-row>
            </div>

            <div class="content" :style="`height:${height};`">
              <el-row justify="start" align="middle">
                <el-col v-for="item in menuWithoutChildren" :key="item.arme_id">
                  <small class="text-center" @click="
                    redirectToPath(
                      item.arme_ruta,
                      item.arme_tipo,
                      item.arme_id
                    )
                    ">
                    {{ item.arme_nombre }}
                  </small>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'CardBuildSubMenu',
  components: {},
  props: {
    menu: {
      type: Array,
      required: true,
      default: () => []
    },
    title: {
      type: String,
      required: true
    },
    color_text: {
      type: String,
      required: false,
      default: 'white'
    },
    variant: {
      type: String,
      required: false
    },
    height: {
      type: String,
      default: 'auto'
    },
    redirectToPath: {
      type: Function,
      required: true
    }
  },
  computed: {
    menuWithChildren() {
      return this.menu.filter(item => item.children.length > 0)
    },
    menuWithoutChildren() {
      return this.menu.filter(item => item.children.length === 0)
    },
    headerStyle() {
      return {
        background: 'linear-gradient(135deg, #006db3, #00c4ff)',
        color: '#fff',
        padding: '20px 20px 20px 20px', 
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center', 
        justifyContent: 'center',
        height: '100px' 
      };
    }
  }
}
</script>

<style scoped>
.text-center-container small {
  color: #ffffff; 
  font-size: 14px; 
  font-weight: bold; 
}


.grid-card-campaign-without-children {
  display: grid;
  grid-template-columns: 120px auto;
  gap: 0px 0px;
  grid-template-areas: 'icon content';
  padding: 20px 0px;
}

.grid-card-campaign {
  display: grid;
  grid-template-columns: 120px auto;
  gap: 0px 0px;
  grid-template-areas: 'icon content';
  padding: 20px 0px;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
  padding: 20px;
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
}

.content {
  padding: 20px;
  grid-area: content;
  overflow-y: scroll;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
  border-top-right-radius: 9px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 0px;
}

@media (max-width: 991px) {
  .grid-card-campaign-without-children {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 0px 0px;
    height: auto !important;
    grid-template-areas:
      'icon'
      'content';
  }

  .grid-card-campaign {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 0px 0px;
    height: auto !important;
    grid-template-areas:
      'icon'
      'content';
  }

  .icon {
    border-top-right-radius: 9px;
    border-top-left-radius: 9px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    height: auto !important;
  }

  .content {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    border-bottom-right-radius: 9px;
    border-bottom-left-radius: 9px;
    height: auto !important;
  }
}

.menu-item-container {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  height: 100px;
  cursor: pointer;
  border-radius: 1rem;
  margin: 0.5rem;
  padding: 0.5rem;
  background-color: #f0f0f0;
}

.text-center {
  width: 100%;
  height: 100%;
  color: #353535; 
  cursor: pointer;
  font-size: 15px; 
  text-align: center; 
  font-weight: bold; 
  transition: color 0.3s, text-decoration 0.3s; 
}

.text-center:hover {
  color: #fff;
  padding: 1px;
  background-color: #01a4d6;
  border-radius: 5px;
}
</style>
